export default __webpack_public_path__ + "static/media/nft.d9e067ac.png";